module.exports = __webpack_public_path__ + "media/images/scoreBet__detailScore__markCorrect--dark-6b52ad81c7c0227ece0e961e23044b4a.png";